import React, { useContext, useState } from 'react';
import { BsImage } from 'react-icons/bs';
import { IoMdClose } from 'react-icons/io';
import { AiOutlineEye } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
import { saveImageOnServer } from 'utils/functions';
import ContainerModal from 'components/Modal';
import { UseTranslationProps } from 'types/UseTranslationProps';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SystemNotifyContext from 'context/SystemNotifyContext';

interface InputImgProps {
	getImage: any;
	initialImage: string;
	idImagem: string;
	label?: string;
	maxWidth?: number;
	maxHeight?: number;
	btnDeleteImage?: boolean;
	traditionalBtnOrBlueBtn?: boolean; //se true usa botão tradicional que mostra imagem ao lado, se não mostra apenas botão azul que não mostra a imagem
	textBlueBtn?: string;
	seeImgBigger?: boolean;
	diseable?: boolean;
}

export default function InputImg({
	label = 'inputImg.labelMessage',
	initialImage,
	getImage,
	idImagem,
	maxWidth = 9999,
	maxHeight = 9999,
	btnDeleteImage = false,
	traditionalBtnOrBlueBtn = true,
	textBlueBtn = 'inputImg.textMessage',
	seeImgBigger = false,
	diseable = false
}: InputImgProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [isShowBtnUnselect, setIsShowBtnUnselect] = useState(false);
	const [isShowImgBigger, setIsShowImgBigger] = useState(false);
	const [isModalImg, setIsModalImg] = useState(false);

	function showOptions() {
		setIsShowBtnUnselect(true);
		setIsShowImgBigger(true);
	}

	function hideOptions() {
		setIsShowBtnUnselect(false);
		setIsShowImgBigger(false);
	}

	// Só pode enviar photo 132x132
	function savePhoto(file: any) {
		setIsShowBtnUnselect(false);
		const reader = new FileReader();
		let height = 0;
		let width = 0;

		//Read the contents of Image File.
		reader.readAsDataURL(file.target.files[0]);
		reader.onload = function (e) {
			//Initiate the JavaScript Image object.
			const image: any = new Image();

			//Set the Base64 string return from FileReader as source.
			image.src = e.target!.result;

			//Validate the File Height and Width.
			image.onload = async function () {
				height = this.height;
				width = this.width;
				if (width <= maxWidth && height <= maxHeight) {
					setMessage('inputImg.savingImg');
					setIsOpenLoad(true);

					const { isSuccess, photo } = await saveImageOnServer(
						file.target.files[0],
						t,
						handleNotify
					);

					if (isSuccess && photo !== null) {
						getImage(photo);
					} else {
						getImage(null);
					}

					// o if abaixo é para deletar a imagem do input para poder subir a mesma se o cliente quiser (foi add recentemente, se algo bugar apagar if abaixo)
					const inputImage: any = document.getElementById(idImagem);
					if (inputImage !== null && inputImage.files !== null) {
						inputImage.value = '';
					}
				} else {
					handleNotify(
						`${t('inputImg.maxImgSize')} ${maxWidth}x${maxHeight}px`,
						'error',
						3000
					);
				}
				setIsOpenLoad(false);
				setMessage('');
			};
		};
	}

	return (
		<S.container>
			<S.inputImg>
				{traditionalBtnOrBlueBtn ? (
					<>
						<p>{t(label)}</p>
						<input
							type="file"
							name={idImagem}
							id={idImagem}
							accept="image/png, image/jpeg, image/jpg"
							onChange={(event) => {
								if (event.target.files!.length > 0) {
									savePhoto(event);
								}
							}}
						/>

						<S.labelWithImage>
							<label htmlFor={idImagem}>{t('inputImg.choiceAFile')}</label>

							{initialImage !== '' &&
							initialImage !== null &&
							initialImage !== undefined ? (
								<S.imageBall
									onMouseOver={showOptions}
									onMouseOut={hideOptions}
									onClick={() => {
										if (btnDeleteImage) {
											getImage('');
										}
									}}
								>
									{btnDeleteImage && (
										<S.unselectImg $isShowBtnUnselect={isShowBtnUnselect}>
											<IoMdClose />
										</S.unselectImg>
									)}

									{seeImgBigger && (
										<S.seeImgBiggerProps
											$seeImgBigger={isShowImgBigger}
											onClick={() => {
												setIsModalImg(true);
											}}
										>
											<AiOutlineEye />
										</S.seeImgBiggerProps>
									)}

									<ContainerModal
										title={t('inputImg.img')}
										isOpenProps={isModalImg}
										setIsOpenModal={() => {
											setIsModalImg(false);
											hideOptions();
										}}
										buttonClose={true}
									>
										<S.modalImg>
											<img src={initialImage} alt="ìcone" />
										</S.modalImg>
									</ContainerModal>

									<img src={initialImage} alt="ìcone" />
								</S.imageBall>
							) : (
								<BsImage
									style={{
										color: color.interface.lightGray
									}}
								/>
							)}
						</S.labelWithImage>
					</>
				) : (
					<>
						<input
							type="file"
							name={idImagem}
							id={idImagem}
							accept="image/png, image/jpeg, image/jpg"
							onChange={(event) => {
								if (event.target.files!.length > 0) {
									savePhoto(event);
								}
							}}
						/>
						<S.blueBtn>
							<label htmlFor={idImagem}>{t(textBlueBtn)}</label>
						</S.blueBtn>
					</>
				)}
			</S.inputImg>

			{diseable && <S.diseableBox />}
		</S.container>
	);
}
